<template>
  <div class="base-file-uploader">
    <label
      :for="id"
      class="base-file-uploader__label"
      aria-label="Select file">
      <input
        :id="id"
        type="file"
        v-bind="$attrs"
        class="base-file-uploader__input"
        @change="handleChange">
      <oie-base-icon :icon="icon" class="base-file-uploader__icon"></oie-base-icon>
      <span>{{ dragText }}</span>
      <oie-base-action
        theme="outlined"
        class="base-file-uploader__button"
        size="large"
        tabindex="-1">
        <template #iconPrepend>
          <oie-base-icon icon="cloud-upload" size="xs"></oie-base-icon>
        </template>
        {{ clickToUploadText }}
      </oie-base-action>
    </label>
    <oie-file-list :files="chosenFiles" @delete="removeFile($event)"></oie-file-list>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'files',
    event: 'change'
  },
  props: {
    id: {
      type: String,
      default: undefined
    },
    icon: {
      type: String,
      default: 'document'
    },
    dragText: {
      type: String,
      default: 'Dra hit en fil eller'
    },
    clickToUploadText: {
      type: String,
      default: 'Ladda upp fil'
    }
  },
  data() {
    return {
      chosenFiles: []
    }
  },
  watch: {
    chosenFiles(newVal) {
      this.$emit('change', newVal)
    }
  },
  methods: {
    handleChange(e) {
      const files = [...e.target.files]
      if(files.length > 0) {
        this.chosenFiles = files
      }
    },
    removeFile(index) {
      this.chosenFiles.splice(index, 1)
    }
  }
}
</script>

<style lang="scss">
.base-file-uploader {
  display: block;
}

.base-file-uploader__label {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px dashed color(gray-1);
  background-color: color(gray-5);
  position: relative;
  padding: measure(half);
  width: 100%;
  margin-bottom: measure(quarter);
}

.base-file-uploader__label:focus-within {
  outline: 3px solid color(black);
}

.base-file-uploader__input {
  position: absolute;
  cursor: pointer;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.base-file-uploader__icon {
  opacity: 0.6;
}

.base-file-uploader__button {
  pointer-events: none;
  margin-top: measure(eighth);
}

</style>
